import React from 'react';

import classNames from 'classnames';
import styles from './skeleton-loader.scss';

export const SkeletonLoader = ({ width }: { width?: number }) => {
  return (
    <div className={styles.skeletonLoader} style={{ width: width ? `${width}px` : '300px' }}>
      <div className={classNames(styles.skeletonText)}></div>
      <div className={styles.skeletonAnimator}></div>
    </div>
  );
};
